import { SR_API_ACTION_GET_ASSIGNED_APARTMENT_LOCATOR_BY_PHONE } from 'api/actionTypes';

export default async function getAssignedApartmentLocatorByPhone({ state, apiClient }, phone) {
  const result = await apiClient.postWithState({
    action: SR_API_ACTION_GET_ASSIGNED_APARTMENT_LOCATOR_BY_PHONE,
    state: state,
    payload: {
      phone: phone,
    },
    onSuccess(apartmentLocator) {
      state.set(['admin', 'userApartmentLocatorId'], apartmentLocator ? apartmentLocator.id : null);
      return apartmentLocator;
    },
  });

  return result;
}
